import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface AuthCardProps {
  children: React.ReactNode;
  className?: string;
  /** Used for slide animation: 'left' | 'right' */
  side?: "left" | "right";
}

/**
 * Glassy auth card: soft shadow, light border, optional backdrop blur.
 * Wraps login/signup form content. No modal overlay — part of page layout.
 */
export function AuthCard({ children, className, side = "left" }: AuthCardProps) {
  return (
    <motion.div
      className={cn(
        "w-full max-w-md min-w-0 rounded-xl border bg-card/95 text-card-foreground shadow-xl",
        "backdrop-blur-sm border-border/80",
        "p-6 md:p-8",
        className
      )}
      initial={false}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      aria-describedby="auth-form-description"
    >
      <div id="auth-form-description" className="sr-only">
        Sign in or create an account
      </div>
      {children}
    </motion.div>
  );
}
